import {
  FETCH_PAYMENT_ORDER_LIST_PENDING,
  FETCH_PAYMENT_ORDER_LIST_REJECTED,
  FETCH_PAYMENT_ORDER_LIST_FULFILLED,
  START_PAYMENT_ORDER_LIST_AUTO_RELOAD,
  STOP_PAYMENT_ORDER_LIST_AUTO_RELOAD,
  SET_ACTIVE_STATUS_FOR_PAYMENT_ORDER_LIST,
  CLEAR_PAYMENT_ORDER_LIST,
  FETCH_FILTER_ATTRS_FULFILLED,
  SELECTED_FILTER_ATTRS,
} from '../constants/paymentOrderList';

let selectedFilterAttrsLS = localStorage.getItem('selectedFilterAttrsLS') || '';
selectedFilterAttrsLS = selectedFilterAttrsLS.length
  ? JSON.parse(selectedFilterAttrsLS)
  : [];

const initialState = {
  pending: false,
  paymentOrders: [],
  autoReloadIntervalId: null,
  activeStatusId: null,
  error: {},
  filterAttrs: [],
  selectedFilterAttrs: selectedFilterAttrsLS,
};

export const paymentOrderList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_ORDER_LIST_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_FILTER_ATTRS_FULFILLED:
      return { ...state, filterAttrs: action.data };

    case SELECTED_FILTER_ATTRS:
      return { ...state, selectedFilterAttrs: action.data };

    case FETCH_PAYMENT_ORDER_LIST_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PAYMENT_ORDER_LIST_FULFILLED:
      return {
        ...state,
        paymentOrders: action.data.results,
        count: action.data.count,
        pending: false,
        error: [],
      };

    case START_PAYMENT_ORDER_LIST_AUTO_RELOAD:
      return {
        ...state,
        autoReloadIntervalId: action.data,
      };

    case STOP_PAYMENT_ORDER_LIST_AUTO_RELOAD:
      return {
        ...state,
        autoReloadIntervalId: null,
      };

    case SET_ACTIVE_STATUS_FOR_PAYMENT_ORDER_LIST:
      return {
        ...state,
        activeStatusId: action.data,
      };

    case CLEAR_PAYMENT_ORDER_LIST:
      const { activeStatusId } = state;
      return {
        ...initialState,
        ...(activeStatusId ? { activeStatusId } : {}),
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paymentOrderList.js